interface Env {
	NODE_ENV: string
	REACT_APP_BASE_URL: string
	REACT_APP_OIDC_AUTHORITY: string
	REACT_APP_V1_URL: string
	ENV_NAME: string
	REACT_APP_INTERNAL_PORTAL_URL: string
	REACT_APP_CUSTOMER_PORTAL_URL: string
	REACT_APP_SUPPLIER_PORTAL_URL: string
	REACT_APP_EATON_PORTAL_URL: string
	REACT_APP_LOCIZE_PROJECTID: string
	REACT_APP_LOCIZE_API_KEY: string
	LOCIZE_PROJECTID: string
	LOCIZE_API_KEY: string
}

declare global {
	interface Window {
		is2Envs: Env
	}
}

export const getEnv = (): Env => {
	let env: Env

	if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
		env = process.env as unknown as Env
	} else {
		env = window.is2Envs
	}

	return env
}

export const isDevEnv = getEnv()?.ENV_NAME === 'DEV'
export const isLocalHost = getEnv()?.NODE_ENV === 'development'
export const isQaEnv = getEnv()?.ENV_NAME === 'QA'
export const isAtoEnv = getEnv()?.ENV_NAME === 'ATO'

export const checkIsLowEnv = (): boolean => isDevEnv || isQaEnv || isLocalHost
